import { useState } from "react";

import { DATE_FORMAT_MONTH_DATE_YEAR } from "shared/lib/constants/time";
import { clsxMerge, safeGetDate } from "shared/lib/helpers";
import { useEffectOnce } from "shared/lib/hooks/use-effect-once";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

import Router from "@/helpers/router";
import { BlogPostI } from "@/interfaces/strapi/collection-types";
import { Tags } from "@/components/base/cms/tags";
import { StrapiImage } from "@/components/base/cms/image";
import { UTMLink } from "@/components/base/utm-link";

export const BlogPostCard = ({
  className,
  ...attributes
}: BlogPostI & PropsWithClassNameI) => {
  const {
    slug,
    post_img,
    headline,
    credits,
    tags,
    createdAt: utcCreatedAt,
  } = attributes;

  const [createdAt, setCreatedAt] = useState<string>();

  useEffectOnce(() => {
    setCreatedAt(safeGetDate(utcCreatedAt, DATE_FORMAT_MONTH_DATE_YEAR));
  });

  return (
    <div
      className={clsxMerge(
        "group/post-category-card relative overflow-hidden",
        "transition-shadow",
        "rounded-xl bg-white/40 backdrop-blur-[10px]",
        "shadow-landing-card",
        "hover:shadow-[0px_0px_8px_4px_rgba(0,0,0,0.1)]",
        className
      )}
    >
      <UTMLink
        href={Router.post(slug)}
        className="z-1 relative block h-full w-full"
      >
        <div className="flex h-full flex-col">
          <div className="relative">
            <div className="absolute left-0 top-0 h-full w-full bg-post-card-image-gradient" />

            <StrapiImage
              className="h-[200px] w-full object-cover"
              image={post_img}
            />
          </div>

          <div className="flex grow flex-col justify-between gap-10 px-6 pb-6 pt-4">
            <div>
              <h3
                title={headline}
                className="mb-3 line-clamp-3 typography-body-2"
              >
                {headline}
              </h3>
            </div>

            <Tags tags={tags} />

            <div className="flex flex-wrap justify-between">
              <div>
                <span className="ae-typography-body1 !font-bold">
                  By {credits}
                </span>
              </div>

              {createdAt && (
                <div>
                  <time className="ae-typography-body1 !font-normal">
                    on {createdAt}
                  </time>
                </div>
              )}
            </div>
          </div>
        </div>
      </UTMLink>
    </div>
  );
};
